export function Input({ className = "", ...props }) {
  return (
    <input
      {...props}
      className={`form-control ${className}`}
    />
  );
}
